import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import IconButton from 'material-ui/IconButton';
import ImagePalette from 'material-ui/svg-icons/image/palette';
import Popover, { PopoverAnimationVertical } from 'material-ui/Popover'

import { ChromePicker } from 'react-color';

class ColorPickerPopup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            elTarget: null,
            isOpenPopover: false,
            iconColor: props.color,
        };

        this.togglePopover = this.togglePopover.bind(this);
        this.closePopover = this.closePopover.bind(this);
        this.changeColor = this.changeColor.bind(this);
    }

    changeColor({ hex }) {
        const { indexLevel, indexRule, changeColor } = this.props;

        this.setState({
            iconColor: hex,
        }, () => {
            changeColor(indexLevel, indexRule, hex);
        });
    }

    togglePopover(e) {
        this.setState({
            isOpenPopover: !this.state.isOpenPopover,
            elTarget: e.target,
        });
    }

    closePopover() {
        this.setState({
            isOpenPopover: !this.state.isOpenPopover,
            elTarget: null,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            iconColor: nextProps.color,
        });
    }

    render() {
        const { elTarget, isOpenPopover, iconColor } = this.state;

        return (
            <Fragment>
                <Popover
                    open={isOpenPopover}
                    anchorEl={elTarget}
                    onRequestClose={this.closePopover}
                    animation={PopoverAnimationVertical}
                    anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                    targetOrigin={{horizontal: 'left', vertical: 'top'}}
                >
                    <ChromePicker
                        color={iconColor}
                        onChangeComplete={ this.changeColor }
                    />
                </Popover>

                <IconButton>
                    <ImagePalette
                        onClick={(e) => {
                            this.togglePopover(e);
                        }}
                        color={iconColor}
                    />
                </IconButton>
            </Fragment>
        );
    }
}

ColorPickerPopup.propTypes = {
    color: PropTypes.string,
    indexLevel: PropTypes.number,
    indexRule: PropTypes.number,
    changeColor: PropTypes.func,
};

export default ColorPickerPopup;


// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Sidebar/ColorPickerPopup.jsx